import React from 'react';
import PropTypes from 'prop-types';

import Select from 'components/Select';
import { twoDigFormat } from 'utils';

const hours = new Array(24).fill(0).map((v, i) => i);
const formatSelectValue = (value) =>
  Number.isInteger(value)
    ? {
        label: twoDigFormat(value),
        value,
      }
    : null;

class HourDropdown extends React.PureComponent {
  render() {
    const { value, onChange } = this.props;
    const options = [
      {
        label: '-',
      },
      ...hours.map(formatSelectValue),
    ];
    return (
      <Select
        options={options}
        width={70}
        placeholder="-"
        value={formatSelectValue(value)}
        onChange={onChange}
      />
    );
  }
}

HourDropdown.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
};

export default HourDropdown;
